import type { InputHTMLAttributes } from "react"
import { cn } from "../utils/cn"

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean
}

export function TextInput({ className, error, ...props }: Props) {
  return <input {...props} className={cn("input-base", error && "border-rose-300 focus:border-rose-400 focus:ring-rose-100", className)} />
}
